<template>
  <StatisticsRow
    v-if="!info.haveSubagents"
    :class="$style.currentProfit"
    :text="$t('home.currentProfit')"
    :value="cashboxProfit"
  />

  <template v-else>
    <StatisticsRow
      :class="$style.totalProfit"
      :text="$t('home.sumProfit')"
      :value="sumProfit"
    />

    <StatisticsRow
      :class="$style.currentProfit"
      :text="$t('home.currentProfitCashbox')"
      :value="cashboxProfit"
    />

    <StatisticsRow
      :class="$style.currentProfit"
      :text="$t('home.currentProfitMaster')"
      :value="masterProfit"
    />
  </template>

  <div :class="$style.separator" />

  <StatisticsRow
    :class="$style.depositsRow"
    :text="texts.deposit"
    :value="depositAllTime"
    :color="colorBlue"
  />

  <StatisticsRow
    :text="texts.withdrawal"
    :value="withdrawalAllTime"
    :color="colorGreen"
  />
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { number } from 'vue-types';

import StatisticsRow from '@/components/StatisticsRow.vue';
import { info } from '@/store/mainInfo';
import variables from '@/styles/variables.module.scss';

const props = defineProps({
  depositAllTime: number().isRequired,
  withdrawalAllTime: number().isRequired,
  totalAllTime: number().isRequired,
  depositFee: number().isRequired,
  withdrawalFee: number().isRequired,
  currentProfit: number().isRequired,
  cashboxProfit: number().isRequired,
  masterProfit: number(),
});

const sumProfit = computed(() => props.masterProfit + props.cashboxProfit || 0);

const { colorBlue, colorGreen } = variables;

const { t } = useI18n();

const toPercent = (value) => `${Math.round(value * 10000) / 100}%`;

const texts = computed(() => ({
  deposit: t('home.fromDeposits', { percent: toPercent(props.depositFee) }),
  withdrawal: t('home.fromWithdrawals', { percent: toPercent(props.withdrawalFee) }),
}));
</script>

<style lang="scss" module>
.totalProfit {
  margin-bottom: 12px;
}
.currentProfit {
  margin-bottom: 10px;
}

.separator {
  height: 1px;
  background: rgba(151, 174, 225, 0.2);
  margin-bottom: 12px;
}

.depositsRow {
  margin-bottom: 17px;
}
</style>
